<app-modal-shell [showFooter]="step() > 1 && !(step() === 3 && selectedTemplate() === 'note')"
  [dismissLabel]="'general.close' | translate"
  (dismiss)="dismiss()">
  <div modalTitle>
    <h2>{{ 'report.new.title' | translate }}</h2>
  </div>
  <div modalHeaderSub>
    <app-step-progress [items]="stepItems"
      [activeStep]="step()"></app-step-progress>
  </div>
  @switch (step()) {
    @case (1) {
      <section class="report-modal">
        <div class="report-modal__context">
          <strong>{{ 'report.new.select' | translate }}</strong>
          <p>{{ 'report.new.info1' | translate }}</p>
        </div>

        <div class="report-modal__list">
          @for (template of templates; track template.name) {
            <button class="report-modal__list-item"
              type="button"
              [disabled]="template.disabled"
              [class.report-modal__list-item--selected]="selectedTemplate() === template.name"
              (click)="onTemplate(template.name)">
              <span class="report-modal__indicator"
                aria-hidden="true">
                @if (selectedTemplate() === template.name) {
                  <ion-icon name="checkmark-outline"></ion-icon>
                } @else {
                  <ion-icon name="document-text-outline"></ion-icon>
                }
              </span>
              <span class="report-modal__list-name">
                {{ 'report.new.list.' + template.name | translate }}
              </span>
            </button>
          } @empty {
            <div class="report-modal__empty">{{ 'general.noItems' | translate }}</div>
          }
        </div>
      </section>
    } @case (2) {
      <section class="report-modal">
        <p class="report-modal__info">{{ 'report.new.info2' | translate }}</p>
        <ng-container [ngTemplateOutlet]="settingsTemplate"></ng-container>
      </section>
    } @case (3) {
      <section class="report-modal">
        <p class="report-modal__info">{{ 'report.new.info3' | translate }}</p>
        @switch (selectedTemplate()) {
          @case ('faultList') {
            <ng-container [ngTemplateOutlet]="notesTemplate"></ng-container>
            <div class="report-modal__actions report-modal__actions--single">
              <button class="report-modal__button report-modal__button--secondary"
                type="button"
                (click)="onNewNote()">
                {{ 'item.add' | translate }}
              </button>
            </div>
          } @case ('tasks') {
            <div class="select-tasks">
              <app-select-tickets [tickets]="tickets$ | async"
                [selectedArea]="selectedArea()"
                [selectedProject]="selectedProject()"
                [selectedJob]="selectedJob()"
                [projects]="projects$ | async"
                [projectPeriods]="projectPeriods$ | async"
                (selectedTickets)="onSelectTicket($event)"></app-select-tickets>
            </div>
          } @case ('note') {
            <app-new-note [site]="site()"
              (saved)="onNoteSave($event)"></app-new-note>
          }
        }
        @if (selectedTemplate() !== 'note') {
        }
      </section>
    } @case (4) {
      <section class="report-modal">
        <p class="report-modal__info">{{ 'report.new.info4' | translate }}</p>
        <ng-container [ngTemplateOutlet]="settingsTemplate"
          [ngTemplateOutletContext]="{ summary: true }"></ng-container>
        @switch (selectedTemplate()) {
          @case ('faultList') {
            <ng-container [ngTemplateOutlet]="notesTemplate"></ng-container>
          } @case ('tasks') {
            <h4 class="report-modal__section-title">{{ 'kanban.title' | translate }}</h4>
            @if ({ projectPeriods: projectPeriods$ | async }; as vm) {
              <app-data-list class="items-container summary"
                [items]="selectedTickets()"
                [trackByField]="null"
                [emptyMessageKey]="'dataView.noResults'">
                <ng-template dataListItem
                  let-ticket>
                  <div class="report-ticket-card">
                    <div class="report-ticket-card__main">
                      <strong>{{ ticket.name | translateTicket | async }}</strong>
                      @if (getTicketPhaseName(ticket, vm.projectPeriods ?? []); as phaseName) {
                        <span class="report-ticket-card__phase">{{ phaseName }}</span>
                      }
                      <div class="report-ticket-card__chips">
                        @if (ticket.roomName) {
                          <span
                            class="report-ticket-card__chip report-ticket-card__chip--neutral">{{ ticket.roomName }}</span>
                        }
                        <span class="report-ticket-card__chip"
                          [class.report-ticket-card__chip--created]="ticket.status === 'created'"
                          [class.report-ticket-card__chip--in-progress]="ticket.status === 'inProgress'"
                          [class.report-ticket-card__chip--done]="ticket.status === 'done' || ticket.status === 'checked'"
                          [class.report-ticket-card__chip--blocked]="ticket.status === 'blocked' || ticket.status === 'late' || ticket.status === 'declined'"
                          [class.report-ticket-card__chip--paused]="ticket.status === 'paused'">
                          {{ 'kanban.status.' + ticket.status | translate }}
                        </span>
                      </div>
                    </div>

                    <div class="report-ticket-card__meta">
                      <span class="report-ticket-card__date-label">{{ 'kanban.dateDeadline' | translate }}</span>
                      <span class="report-ticket-card__date">{{ getTicketDueDate(ticket) | date:'d.M.yyyy' }}</span>
                    </div>
                  </div>
                </ng-template>
              </app-data-list>
            }
            <ion-item lines="none"
              class="report-modal__toggle-row">
              <ion-toggle [(ngModel)]="includeImages">
                {{ 'tickets.printImages' | translate }}
              </ion-toggle>
            </ion-item>
          }
        }
      </section>
    }
  }

  <div modalFooter
    class="report-modal__footer">
    @if (step() === 2 || (step() === 3 && selectedTemplate() !== 'note') || step() === 4) {
      <button class="report-modal__button report-modal__button--secondary"
        type="button"
        (click)="onStep(-1)">
        {{ 'general.prev' | translate }}
      </button>
    }

    @if (step() === 2 || (step() === 3 && selectedTemplate() !== 'note')) {
      <button class="report-modal__button report-modal__button--primary"
        type="button"
        (click)="onStep(1)">
        {{ 'general.next' | translate }}
      </button>
    }

    @if (step() === 4) {
      <button class="report-modal__button report-modal__button--primary"
        type="button"
        (click)="onDone()">
        {{ 'general.done' | translate }}
      </button>
    }
  </div>
</app-modal-shell>
<ng-template #settingsTemplate
  let-summary="summary">
  <h4 class="report-modal__section-title">{{ 'site.management' | translate }}</h4>
  @if ({
    areas: areas$ | async,
    contractors: contractors$ | async,
    projects: projects$ | async,
    jobs: jobs$ | async
  }; as vm) {
    @if (!summary || selectedContractor()) {
      <ion-item button="true"
        lines="none"
        class="report-modal__picker-item"
        [disabled]="!['manager'].includes(role())"
        (click)="selectItem(vm.contractors, selectedContractor)">
        <div class="tw:flex tw:justify-between tw:w-full">
          {{ 'logistics.form.contractor' | translate }}
          <div>
            @if (selectedContractor()) {
              {{ selectedContractor().name }}
            } @else {
              {{ 'general.notSelected' | translate }}
            }
          </div>
        </div>
      </ion-item>
    }
    @if (!summary || selectedArea()) {
      <ion-item button="true"
        lines="none"
        class="report-modal__picker-item"
        (click)="selectItem(vm.areas, selectedArea)">
        <div class="tw:flex tw:justify-between tw:w-full">
          {{ 'calendar.site.area' | translate }}
          <div>
            @if (selectedArea()) {
              {{ selectedArea().name }}
            } @else {
              {{ 'general.notSelected' | translate }}
            }
          </div>
        </div>
      </ion-item>
    }
    @if (!summary || selectedProject()) {
      <ion-item button="true"
        lines="none"
        class="report-modal__picker-item"
        [disabled]="selectedContractor() == null"
        (click)="selectItem(vm.projects, selectedProject)">
        <div class="tw:flex tw:justify-between tw:w-full">
          {{ 'report.new.project' | translate }}
          <div>
            @if (selectedProject()) {
              {{ selectedProject().name }}
            } @else {
              {{ 'general.notSelected' | translate }}
            }
          </div>
        </div>
      </ion-item>
    }
    @if (!summary || selectedJob()) {
      <ion-item button="true"
        lines="none"
        class="report-modal__picker-item"
        [disabled]="selectedProject() == null"
        (click)="selectItem(vm.jobs, selectedJob)">
        <div class="tw:flex tw:justify-between tw:w-full">
          {{ 'site.job' | translate }}
          <div>
            @if (selectedJob()) {
              {{ selectedJob().name }}
            } @else {
              {{ 'general.notSelected' | translate }}
            }
          </div>
        </div>
      </ion-item>
    }
  }
</ng-template>
<ng-template #notesTemplate>
  <h4 class="report-modal__section-title">{{ 'report.new.images' | translate }} ({{ notes().length }})</h4>
  @for (note of notes(); track note; let i = $index) {
    <ion-item lines="none"
      class="report-modal__note-item">
      <ion-thumbnail slot="start">
        @if (note.images.length > 0) {
          <img [src]="note.images[0]" />
        } @else {
          <img src="./assets/images/default-loading-image.png" />
        }
      </ion-thumbnail>
      <div>
        <ion-note>
          {{ note.area }}
        </ion-note>
        <span class="name">
          {{ note.name }}
        </span>
        <div class="ellipsis tw:truncate">
          {{ note.text }}
        </div>
      </div>
    </ion-item>
    <ion-button class="remove"
      color="danger"
      fill="clear"
      shape="round"
      (click)="removeNote(i, note.name)">
      <ion-icon slot="icon-only"
        name="close-circle-outline"></ion-icon>
    </ion-button>
  } @empty {
    <app-no-results></app-no-results>
  }
</ng-template>